import type { OrganizationResponse } from '../types/models.js'
import { API_BASE } from './client.js'
import { ApiError } from '../types/api.js'

function token(): string | null {
  return localStorage.getItem('mf_access')
}

function authHeaders(): Record<string, string> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  const t = token()
  if (t) headers['Authorization'] = `Bearer ${t}`
  return headers
}

export interface UpdateOrganizationData {
  name: string
  description?: string | null
  pricePrecisionMode?: string
}

export async function getOrganization(organizationId: string): Promise<OrganizationResponse> {
  const res = await fetch(`${API_BASE}/organizations/${organizationId}`, { headers: authHeaders() })
  if (!res.ok) {
    const b = await res.json()
    throw new ApiError(res.status, b?.error ?? { code: 'UNKNOWN', message: 'Failed to load organization' })
  }
  const b = await res.json()
  return b.data
}

export async function updateOrganization(
  organizationId: string,
  data: UpdateOrganizationData,
): Promise<OrganizationResponse> {
  const res = await fetch(`${API_BASE}/organizations/${organizationId}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(data),
  })
  if (!res.ok) {
    const b = await res.json()
    throw new ApiError(res.status, b?.error ?? { code: 'UNKNOWN', message: 'Failed to update organization' })
  }
  const b = await res.json()
  return b.data
}